import React from 'react'

const HeaderFaq = props => (
  <header id="header">
    <h1>FAQ</h1>
    <p>Preguntas Más Frecuentes</p>
  </header>
)

export default HeaderFaq
